var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#405973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.74224 6.67285C9.68761 6.67284 9.63353 6.68361 9.58307 6.70454C9.53262 6.72548 9.4868 6.75617 9.44824 6.79485L5.28624 10.9559C5.21241 11.0347 5.17212 11.1391 5.17388 11.247C5.17564 11.355 5.21932 11.4581 5.29567 11.5344C5.37203 11.6108 5.47508 11.6544 5.58304 11.6562C5.69101 11.658 5.79543 11.6177 5.87424 11.5439L9.74224 7.67285L13.6092 11.5449C13.6474 11.5856 13.6933 11.6182 13.7443 11.6408C13.7953 11.6634 13.8503 11.6755 13.906 11.6764C13.9618 11.6773 14.0172 11.667 14.0689 11.6461C14.1206 11.6251 14.1675 11.594 14.207 11.5546C14.2464 11.5152 14.2775 11.4682 14.2984 11.4165C14.3194 11.3648 14.3297 11.3094 14.3288 11.2537C14.3279 11.1979 14.3157 11.1429 14.2932 11.0919C14.2706 11.0409 14.2379 10.995 14.1972 10.9569L10.0362 6.79485C9.99767 6.75617 9.95185 6.72548 9.9014 6.70454C9.85095 6.68361 9.79686 6.67284 9.74224 6.67285Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.91c2d7fc0386a931be4bfdbdbdceb82d.svg";
export { ForwardRef as ReactComponent };